import { getCdnUrl } from '@desygner/helpers/helpers/cdn-helpers';
export let desygnerFunctions;

(function ($) {
  desygnerFunctions = {
    // Change the browser title when the tab is out of focus
    changeBrowserTabMessage: function () {
      var message = desygnerData.browserTabMessage;
      var original = document.title;

      $(window).focus(function () {
        document.title = original;
      }).blur(function () {
        document.title = message;
      });
    },

    preloadSystemScripts: function () {
      const urls = [
        getSystemJsUrl('/vendor/system.js?v0.19.46-custom'),
        getSystemJsUrl('/bundles/desygnerbrand/config.js'),
        ...getTranslationsUrl()
      ];

      for (const url of urls) {
        const link = document.createElement('link');
        const type = url.includes('translation') ? 'fetch' : 'script';
        link.setAttribute('rel', 'preload');
        link.setAttribute('href', url);
        link.setAttribute('as', type);
        link.setAttribute('crossorigin', '');

        document.head.appendChild(link);
      }
    },

    getAureliaLibraries: (function () {
      let systemDeferred;

      return function ($container) {
        const moduleDeferred = $.Deferred();

        if (systemDeferred) {
          systemDeferred.then(initializeModule);
        } else {
          systemDeferred = $.Deferred();
          loadSystemJs();
        }

        return moduleDeferred;

        function loadSystemJs() {
          var baseUrl = CONFIG['desygner_url'];

          getScript(getSystemJsUrl('/vendor/system.js?v0.19.46-custom')).then(function () {
            System.config({ baseURL: baseUrl });

            getScript(getSystemJsUrl('/bundles/desygnerbrand/config.js')).then(function () {
              System.registerDynamic('jquery', [], false, function (require, exports, module) {
                module.exports = window.jQuery;
              });

              autoloadModule();
            });
          });
        }

        function autoloadModule() {
          const appHost = $container[0];

          System.import('aurelia-bootstrapper').then(function (aurelia) {
            const observer = new MutationObserver((mutationsList, observer) => {
              for (let mutation of mutationsList) {
                if (mutation.type === 'childList' && mutation.target === appHost) {
                  systemDeferred.resolve(aurelia.bootstrap);
                  moduleDeferred.resolve();
                  observer.disconnect();
                }
              }
            });

            observer.observe(appHost, { childList: true });
          });
        }

        function initializeModule(bootstrap) {
          const appHost = $container[0];
          const moduleId = appHost.getAttribute('aurelia-app');

          if (appHost.childNodes.length === 0) {
            System.import(moduleId).then(function (module) {
              bootstrap(function (aurelia) {
                aurelia.host = appHost;
                aurelia.configModuleId = moduleId || null;

                module.configure(aurelia);
                const observer = new MutationObserver((mutationsList, observer) => {
                  for (let mutation of mutationsList) {
                    if (mutation.type === 'childList' && mutation.target === appHost) {
                      moduleDeferred.resolve();
                      observer.disconnect();
                    }
                  }
                });

                observer.observe(appHost, { childList: true });
              });
            });
          }
        }
      };
    })()
  };

  window.location.protocol.includes('https') && desygnerFunctions.preloadSystemScripts();
  desygnerFunctions.changeBrowserTabMessage();

  function getScript(url, callback) {
    // Rewriting getScript because it makes no sense and invalidate cache intentionally
    return $.ajax({
      url: url,
      type: 'get',
      dataType: 'script',
      scriptAttrs: { crossorigin: '' },
      success: callback,
      cache: true
    });
  }

  function getSystemJsUrl(url) {
    url = url.replace(/^\/+/, '');

    if (CONFIG['environment'] === 'dev') {
      return CONFIG['assets_url'] + '/' + url + '?' + CONFIG['desygner_version'];
    }

    const isLive = /^v\d+\.\d+\.\d+$/.test(CONFIG['desygner_version']);
    const isRc = /^rc\/\d+\-\d+\-\d+$/.test(CONFIG['desygner_version']);
    const match = url.match(/^(.+)config\.js$/);

    if (match) {
      const versionSlug = CONFIG['desygner_version'].replaceAll('/', '-').replaceAll('.', '_');
      url = `${match[1]}config--${versionSlug}.js`;
    }

    let path = `https://s3.amazonaws.com/assets.desygner.com/assets/build/${url}`;

    if (isLive) {
      path = `https://static.desygner.com/assets/build/${url}`;
    } else if (isRc) {
      path = `https://static.builddesygner.xyz/assets/build/${url}`;
    }

    return path;
  }

  function getTranslationsUrl() {
    const lang = getLocaleFromBrowser() || CONFIG.locale;
    const url = (
      CONFIG.environment === 'prod' &&
        !CONFIG.base_url.match(/qa(webrand|desygner)\.xyz/) &&
        !CONFIG.base_url.match(/[\w+]-(webrand|desygner)\.com/)
    )
      ? 'https://static.desygner.com'
      : 'https://s3.amazonaws.com/assets.inkive.com';

    let translations = ['setup', 'join', 'base'];
    if (pageTemplate && pageTemplate === 'pricing') {
      translations = translations.concat('billing', 'users');
    }

    return translations.map(t => getCdnUrl(`${url}/translations/${lang}/${t}.json`));
  }

  function getLocaleFromBrowser () {
    if (navigator && navigator.language) {
      const regex = new RegExp(/[a-z]-[A-Z]/);

      if (regex.test(navigator.language)) {
        return sanitizeHyphenedLocale(navigator.language);
      }

      if (navigator.language.length === 2) {
        return navigator.language;
      }
    }

    return null;

    function sanitizeHyphenedLocale (locale) {
      return locale === 'en-US'
        ? 'en_us'
        : locale.split('-')[0];
    }
  }
})(jQuery);

export function setCookie(cname, cvalue) {
  var exdays = arguments.length <= 2 || arguments[2] === undefined ? 28 : arguments[2];

  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function deleteCookie(cname) {
  document.cookie = cname +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export function redirectToApp (tab = 'create') {
  const isOtherMobile = /webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  const isAndroid = /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  if (isIOS) {
    const universalLink = `https://${window.location.hostname}/create/`; //  Universal Link
    setCookie('redirectAppStore', '1');
    window.location.href = universalLink;
  } else if (isAndroid || isOtherMobile) {
    const scheme = `anydesygnerapp://tab/${tab}`;
    const store = 'https://play.google.com/store/apps/details?id=com.delgeo.desygner';
    deferredRedirect(scheme, store);
  } else {
    const host = CONFIG.host_desygner;
    const deepLinkBaseUrlMap = {
      make: 'https://links.dev.fluer.com',
      qa: 'https://links.dev.fluer.com',
      qc: 'https://links.dev.fluer.com',
      build: 'https://links.build.fluer.com',
      'desygner.com': 'https://links.fluer.com'
    }
    const deepLinkBaseUrl = Object.keys(deepLinkBaseUrlMap).find(key => host.includes(key)) ? deepLinkBaseUrlMap[key] : 'https://links.fluer.com';

    window.location.href = `https://${deepLinkBaseUrl}/desygner-free-features`;
  }

  function deferredRedirect(scheme, store) {
    window.location.href = scheme;

    setTimeout(function () {
      window.location.href = store;
    }, 5000);
  }
}
